
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/logowanie-pracownik",
      function () {
        return require("private-next-pages/logowanie-pracownik.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/logowanie-pracownik"])
      });
    }
  